import React from 'react';
import { Link } from 'react-router-dom';
import ProfileService from '../../../services/profile.service';
import './style.css';

const Logo = ({ logo, companyTitle }) => (
  <React.Fragment>
    <Link to="/" className="logo">
      { !!logo && (
        <span className="loginlogo logo-login-responsible logo">
          <img
            src={logo}
            alt="logo"
            onError={(e) => { e.target.src = ProfileService.defaultLogo; }}
          />
        </span>
      )}
      {!logo && (<h1 className="logo-text">{companyTitle}</h1>)}
    </Link>
  </React.Fragment>
);

Logo.propTypes = {
};

export default Logo;



// WEBPACK FOOTER //
// ./src/components/login/logo/Logo.jsx